(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kasa-brands-tabs_6"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kasa-brands')) {
    class KasaBrands extends HTMLElement {
      connectedCallback() {
        this.tabList = this.querySelector('[role="tablist"]');
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
        if (!this.tabList || this.tabs.length === 0) return;

        this.abortController = new AbortController();
        const options = { signal: this.abortController.signal };

        this.tabList.addEventListener('click', (event) => {
          const tab = event.target.closest('[role="tab"]');
          if (tab) this.activate(tab.dataset.brandTab, { scroll: true });
        }, options);

        this.tabList.addEventListener('keydown', (event) => this.onKeydown(event), options);

        // Editor de temas: al seleccionar un bloque se abre su marca
        this.addEventListener('shopify:block:select', (event) => {
          const blockId = event.detail && event.detail.blockId;
          if (blockId) this.activate(blockId, { scroll: true });
        }, options);
      }

      disconnectedCallback() {
        if (this.abortController) this.abortController.abort();
      }

      onKeydown(event) {
        const currentIndex = this.tabs.indexOf(document.activeElement);
        if (currentIndex === -1) return;

        let nextIndex = null;
        switch (event.key) {
          case 'ArrowRight':
          case 'ArrowDown':
            nextIndex = (currentIndex + 1) % this.tabs.length;
            break;
          case 'ArrowLeft':
          case 'ArrowUp':
            nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
            break;
          case 'Home':
            nextIndex = 0;
            break;
          case 'End':
            nextIndex = this.tabs.length - 1;
            break;
          default:
            return;
        }

        event.preventDefault();
        const nextTab = this.tabs[nextIndex];
        this.activate(nextTab.dataset.brandTab, { scroll: true });
        nextTab.focus();
      }

      activate(id, { scroll = false } = {}) {
        this.tabs.forEach((tab) => {
          const isActive = tab.dataset.brandTab === id;
          tab.classList.toggle('is-active', isActive);
          tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
          tab.tabIndex = isActive ? 0 : -1;
          if (isActive && scroll) this.centerTab(tab);
        });

        this.panels.forEach((panel) => {
          const isActive = panel.dataset.brandPanel === id;
          panel.classList.toggle('is-active', isActive);
          panel.hidden = !isActive;
        });
      }

      // Centra la pestaña dentro de la lista sin mover el scroll vertical de la página
      centerTab(tab) {
        const list = this.tabList;
        if (list.scrollWidth <= list.clientWidth) return;

        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const left = tab.offsetLeft - (list.clientWidth - tab.offsetWidth) / 2;
        list.scrollTo({ left, behavior: reduceMotion ? 'auto' : 'smooth' });
      }
    }

    customElements.define('kasa-brands', KasaBrands);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
